<template>
  <section class="section-load-day">
    <el-row type="flex" justify="center">
      <el-button
        type="info"
        plain
        class="mob-btn ld-btn"
        @click="$emit('load')"
      >
        Назад к списку дней
      </el-button>
    </el-row>
    <bid-mobile :bid="bid" :day="day" :freight="freights[bid.freight_id]" />
    <el-row type="flex" justify="center" align="middle">
      <el-button
        v-if="isOpen && isFuture && !isExp"
        type="success"
        class="mob-btn ld-btn"
        @click="addAuto = true"
      >
        Добавить авто и водителя в заявку
      </el-button>
      <b v-if="!isOpen || !isFuture" class="closed">
        {{ !isFuture ? 'Предыдущий день ' : '' }}
        {{ !isOpen ? '(закрыт)' : '' }}
      </b>
      <el-button
        v-if="canAction('download_register') && responses.length"
        type="primary"
        class="mob-btn"
        :loading="loading"
        @click="formationRegistry"
      >
        Скачать реестр
      </el-button>
    </el-row>
    <driver-list-mobile
      :id="bid.id"
      :type="bid.type_code"
      :responses="responses"
      :disabled="!isOpen || !isFuture || isExp"
      @change="onChangeAuto"
      @updated="getResponses"
    />
    <driver-add-mobile
      :added="added"
      :visible="addAuto"
      :day="day"
      :type="bid.type_code"
      @changed="updated"
    />
    <driver-edit-mobile
      :response="response"
      :visible="editAuto"
      :added="added"
      @changed="onChangeAuto"
    />
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { isFutures } from '@/helpers/functions'
import { mapActions, mapGetters } from 'vuex'
import BidMobile from '../BidMobile/index'
import DriverAddMobile from './DriverAddMobile'
import DriverEditMobile from './DriverEditMobile'
import DriverListMobile from './DriverListMobile'

const docAPI = RepositoryFactory.get('document')

export default {
  name: 'LoadDayMobile',
  components: {
    DriverListMobile,
    DriverEditMobile,
    DriverAddMobile,
    BidMobile,
  },
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    day: {
      type: Object,
      default: () => {},
    },
    freights: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      addAuto: false,
      editAuto: false,
      response: {},
      loading: false,
    }
  },
  computed: {
    ...mapGetters({ responses: 'loadDay/getResponses' }),
    added() {
      const obj = { autos: [], drivers: [] }

      for (let k in this.responses) {
        if (!Object.prototype.hasOwnProperty.call(this.responses, k)) {
          continue
        }
        const { automobile_id, driver_id } = this.responses[k]

        obj.autos.push(automobile_id)
        obj.drivers.push(driver_id)
      }

      return obj
    },
    isOpen() {
      return this.day && this.day.status !== 1
    },
    isFuture() {
      return isFutures(this.day.load_date)
    },
    isExp() {
      return this.userInfo.user_type === 2
    },
    isExpOrAdmin() {
      return this.isAdminOrCeoRole || this.isExp
    },
  },
  mounted() {
    this.getResponses()
  },
  methods: {
    ...mapActions({
      fetchResponsesInDay: 'loadDay/fetchResponsesInDay',
      fetchHomeBid: 'bids/fetchHomeBid',
    }),
    formationRegistry() {
      this.loading = true
      docAPI
        .getRegistry(this.day.id, this.bid.user_org_inn)
        .then(res =>
          this.downloadRegistry({
            res,
            headerContent: 'реестр_' + this.bid.load_point,
          }),
        )
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    onChangeAuto(response = {}, flag = false, update = false) {
      this.response = response === null ? {} : response
      this.editAuto = flag

      if (!flag && response !== null) {
        this.getResponses()
      }
      if (update) {
        this.fetchHomeBid({
          bid_id: this.bid.id,
          user_type: this.userInfo.user_type,
        })
      }
    },
    updated(flag = 1) {
      this.addAuto = false

      if (flag) {
        this.getResponses()
        this.fetchHomeBid({
          bid_id: this.bid.id,
          user_type: this.userInfo.user_type,
        })
      }
    },
    getResponses() {
      if (this.day.id) {
        this.fetchResponsesInDay({
          load_day_id: this.day.id,
          'per-page': 200,
          with_stats: 0,
        })
      }
    },
  },
}
</script>
